import { createTheme } from "@mui/material/styles";
import { EXIT_MS, MenuTransition } from "./MenuTransition";

const transitionDuration = { enter: 0, exit: EXIT_MS };

export const menuMotionTheme = createTheme({
  components: {
    MuiPopover: {
      defaultProps: { TransitionComponent: MenuTransition, transitionDuration },
    },
    // Menu passes its own transitionDuration ("auto") down to Popover.
    MuiMenu: {
      defaultProps: { transitionDuration },
    },
  },
});
